
export default function readUrl() {

    var obj = {};

    const searchParams = new URLSearchParams(window.location.search);

    //var Cityloc = "Hathin";
    var sateLoc = searchParams.get("state");
    var cityLoc = searchParams.get("city");
    var countryLoc = searchParams.get("country");

    if (countryLoc == null) countryLoc = "";
    if (cityLoc == null) cityLoc = "";
    if (sateLoc == null) sateLoc = "";
    //const urlParts = rawUrl.split('/');
    //const location = urlParts.length === 4 ? `in ${urlParts[urlParts.length - 1].replace(/-/g, ' ').toUpperCase()}` : '';
    // SEO Meta Information
    const metaTitle = `Best BI Embedded ERP Software ${cityLoc} | ERP Systems | Business Management Solutions - Tejaxo Software`;
    const metaDesc = `Tejaxo Software is a High Rated Indian BI Embedded ERP Software ${cityLoc}, providing award-winning Enterprise Resource Planning (ERP) software, business management solutions, services and support.`;
    const metaKey = `Tejaxo BI Embedded ERP Software ${cityLoc}, Tejaxo BI Embedded ERP, ERP Software, Tejaxo BI`;

    var condText = "";

    if (cityLoc !== "") {
        condText = "In " + cityLoc + "," + sateLoc + "," + countryLoc;
    }
    else if (sateLoc !== "") {
        condText = "In " + sateLoc + "," + countryLoc;
    }
    else if (countryLoc !== "") {
        condText = " In " + countryLoc;
    }

    var mauthor = "Tejaxo Technologies Pvt.Ltd.";
    var ogsite = "tejaxo";
    var Ogtype = "website";//website or article

    obj.metaTitle = metaTitle;
    obj.metaDesc = metaDesc;
    obj.metaKey = metaKey;
    obj.mauthor = mauthor;
    obj.ogsite = ogsite;
    obj.Ogtype = Ogtype;
    obj.condText = condText;

    return obj;
}

